import { render, staticRenderFns } from "./WarnReasonList.vue?vue&type=template&id=a0ca1bb8"
import script from "./WarnReasonList.vue?vue&type=script&lang=js"
export * from "./WarnReasonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports